import { SyntheticEvent, useState } from "react";
import FocusLock from "react-focus-lock";
import { MailIcon } from "@/shared/icons";
import { Button, TextInput } from "@/shared/ui";

type Props = {
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
  email: string;
  onChangeEmail: (value: string) => void;
  error?: string;
  pending?: boolean;
};

export default function AuthResetPasswordEmail({
  onSubmit,
  onChangeEmail,
  email,
  error = "",
  pending = false,
}: Props) {
  const [touch, setTouch] = useState(false);

  return (
    <FocusLock className="contents">
      <form
        noValidate
        onSubmit={(e) => {
          onSubmit(e);
          setTouch(true);
        }}
        className="gap-3 grow flex flex-col"
      >
        <TextInput
          type="text"
          placeholder="example@mail.com"
          value={email}
          title="Введите E-mail указанный при регистрации:"
          icon={<MailIcon size={18} />}
          invalid={touch && !email ? "Введите почту" : ""}
          onChange={onChangeEmail}
          className="text-center"
          loading={pending}
        />
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button submit className="w-full" loading={pending}>
            Отправить код
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
